import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterBonusReport from 'views/agent/reports/bonusReport/filterBonusReport'; // Importing FilterBonusReport component
import TableBonusReport from 'views/agent/reports/bonusReport/tableBonusReport'; // Importing TableBonusReport component
import DetailsBonusReport from 'views/agent/reports/bonusReport/detailsBonusReport'; // Importing DetailsBonusReport component
import RecordBonusReport from 'views/agent/reports/bonusReport/recordBonusReport'; // Importing RecordBonusReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Bonus Report View.
 * @extends JetView
 */
export default class BonusReportView extends JetView {
    /**
     * Configures the layout of the Bonus Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section of the layout containing record and details reports
        const right = {
            type: 'wide',
            rows: [RecordBonusReport, DetailsBonusReport],
        };

        // Toolbar configuration for pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch
                },
            ],
        };

        // Left section of the layout containing filters and tables
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the report title
                            label: _('Reporte de Bonos'), // Translated title
                            width: 300,
                        },
                    ],
                },
                FilterBonusReport, // Filter component for the bonus report
                TableBonusReport, // Table component for displaying bonus data
                toolbar, // Including the pagination toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide',
            responsive: true,
            css: 'out', // CSS class for styling
            cols: [left, right], // Defining the columns layout
        };
    }
}

// FILE DOCUMENTED
